import FieldDimensionId from '@core/constants/FieldDimension';
import { MaterialId } from '@core/constants/Material';
import { FenceDestinationId, FenceFillingId, FencePolesId } from '@core/constants/Shape';
import {
    IDimensionUnit,
    IFormFieldDimension,
    IFormFieldDimensionDefaultValueKey,
    IFormFieldMaterial, IFormFieldShape, IFormFieldShapeMaterial, IFormInputType,
} from '../../../interfaces/Form';
import {
    allGlasses,
    allMetals,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsFenceDestination: IFormFieldShape = {
    value   : undefined,
    options : [
        FenceDestinationId.FenceWindow,
        FenceDestinationId.FenceTerrace,
        FenceDestinationId.FenceStaircase,
        FenceDestinationId.FenceMezzanine,
    ],
    required: true,
};

const fieldsFencePolesShape: IFormFieldShape = {
    value   : undefined,
    options : [
        FencePolesId.FenceRoundPoles,
        FencePolesId.FenceSquarePoles,
    ],
    required: false,
};

const fieldFencePolesMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                ...allMetals,
            ],
            [
                MaterialId.DriftWood,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Acacia,
                MaterialId.Mahogany,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Garapa,
            ],
        ),
        required: false,
    },
};

export const fieldFenceRailingMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                ...allMetals,
            ],
            [
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Chestnut,
                MaterialId.Acacia,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Mahogany,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Teak,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Garapa,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
            ],
        ),
        required: false,
    },
};

export const fieldsFencePoles: IFormFieldShapeMaterial = {
    shape    : fieldsFencePolesShape,
    material : fieldFencePolesMaterial,
};

export const fieldsFenceMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allSolidWoods,
                MaterialId.BlackLocust,
                MaterialId.Larch,
                ...allMetals,
                ...allGlasses,
            ],
            [
                MaterialId.WagonfloorDark,
                MaterialId.WagonfloorLight,
                MaterialId.OakOld,
                MaterialId.Walnut,
                MaterialId.Ash,
                MaterialId.AshOlive,
                MaterialId.Rust,
                MaterialId.Brass,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
                MaterialId.Acacia,
                MaterialId.Mahogany,
                MaterialId.Elm,
                MaterialId.Alderwood,
                MaterialId.Birch,
                MaterialId.Maple,
                MaterialId.Wenge,
                MaterialId.Cherrywood,
                MaterialId.Ebony,
                MaterialId.Garapa,
            ],
        ),
        required: false,
    },
};

export const fieldsFenceFilling: IFormFieldShape = {
    value   : undefined,
    options : [
        FenceFillingId.FenceFillingUniform,
        FenceFillingId.FenceFillingSimpleSmooth,
        FenceFillingId.FenceFillingDoubleSmooth,
    ],
    required: false,
};

export const fieldsFenceDimension: IFormFieldDimension = {
    [FieldDimensionId.Height]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 90,
        range         : { min: 500, max: 2000 },
        required      : true,
        defaultValue  : 1000,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardLength, 1000],
        ],
    },
    [FieldDimensionId.Length]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 100,
        range         : { min: 1000, max: 10000 },
        required      : true,
        defaultValue  : 1500,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardWidth, 1500],
        ],
    },
    [FieldDimensionId.Depth]: {
        value         : undefined,
        type          : IFormInputType.Range,
        unit          : IDimensionUnit.Centimeters,
        step          : 10,
        range         : { min: 50, max: 200 },
        required      : true,
        defaultValue  : 80,
        defaultValues : [
            [IFormFieldDimensionDefaultValueKey.StandardThickness, 80],
        ],
    },
};
